import React, {useCallback, useEffect, useMemo} from 'react'
import {useTranslation} from '@lib/intl/useTranslations'
import TagText from '@component/Text/TagText'
import CloseIcon from '@svg/common/ic_close_bold.svg'
import {BottomSheet} from '@component/core/BottomSheetLoader'
import WizIconButton from '@component/buttons/WizIconButton'
import useLogin from '@hook/useLogin'
import useNavigation from '@hook/useNavigation'
import IconWarning from '@svg/common/ic_warning.svg'
import useQueryFetchMe from '@hook/query/account/useQueryFetchMe'
import {PROPaymentMethod} from '@type/profile'
import useProStatus from '@hook/useProStatus'

interface IProps {
    id?: string
}

const ICON_SIZE = 22
const ProNoticeBottomSheet: React.FC<IProps> = ({}) => {
    const t = useTranslation()
    const {goAccountProPayment} = useNavigation()
    const {data: me} = useQueryFetchMe(undefined, false)
    const {isExpire, expireDays, proCopyExchange} = useProStatus(me)
    const {isLogin, isMe} = useLogin(me?.id)

    const bottomSheetContents = useMemo(() => {
        if (!isMe || !isLogin()) return null
        // == 웹 결제 만료 3일전 ==
        if (me?.pro_method === PROPaymentMethod.crypto && !isExpire && expireDays < 3 && !proCopyExchange) {
            return t('mainLeaderboard.bottomSheet.pro.expiredInDays', {count: expireDays})
        }
        // == 웹 결제 카피 트레이딩 중 && 만료 3일전 ==
        if (me?.pro_method === PROPaymentMethod.crypto && !isExpire && expireDays < 3 && proCopyExchange) {
            return t('mainLeaderboard.bottomSheet.pro.expiredInDays.with.copy', {
                count: expireDays,
                exchange: proCopyExchange,
            })
        }
        // == 카피 트레이딩 중 && 만료 ==
        if (isExpire && proCopyExchange) {
            return t('mainLeaderboard.bottomSheet.pro.expired', {exchange: proCopyExchange})
        }
    }, [isMe, isLogin, me?.pro_method, isExpire, expireDays, proCopyExchange, t])

    const openBottomSheet = useCallback(() => {
        if (!bottomSheetContents) return
        BottomSheet?.show({
            className: 'bg-red_tint02 dark:bg-dark_red_tint02',
            children: (
                <ProNoticeBottomSheetItem
                    text={bottomSheetContents}
                    func={goAccountProPayment}
                    onClickClose={closeBottomSheet}
                />
            ),
        })
    }, [bottomSheetContents, goAccountProPayment])

    useEffect(() => {
        openBottomSheet()
        return () => {
            closeBottomSheet()
        }
    }, [openBottomSheet])

    const closeBottomSheet = () => {
        BottomSheet?.hide()
    }

    return null
}
const ProNoticeBottomSheetItem: React.FC<{text: string; func: () => void; onClickClose: () => void}> = ({
    text,
    func,
    onClickClose,
}) => {
    return (
        <div className={'flex items-center justify-between gap-x-[10px] pr-[30px]'}>
            <div>
                <IconWarning width={ICON_SIZE} heigth={ICON_SIZE} className={'fill-red dark:fill-dark_red'} />
            </div>
            <TagText
                className={`flex-1 text-body1 text-red_shade dark:text-dark_red_shade text-left ml-[${ICON_SIZE}px]`}
                funcList={[{id: 'pro_notice', func: func}]}>
                {text}
            </TagText>
            <WizIconButton onClick={onClickClose} showHover={false}>
                <CloseIcon width={ICON_SIZE} heigth={ICON_SIZE} className={'fill-gray02 dark:fill-dark_gray02'} />
            </WizIconButton>
        </div>
    )
}
export default ProNoticeBottomSheet
